export default __webpack_public_path__ + "media/images/print-62a1d1ba469ce783b7f312265c68cc7b.png";